// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Brazil from '../_raw/flag/icon_flag_brazil.png';

export default () => <img src={Brazil} alt="Brazil" />;
